import { AnyAction, combineReducers } from 'redux'

import { ActionTypes } from '../actions'
import ui, { ConfigProviderState, initialUiState } from './ui'
import waypoints, { initialWaypointsState, WaypointsState } from './waypoints'
import { Params as ParamsState } from 'common/services/QueryParams'

import application, { ApplicationState, initialApplicationState } from 'embed/reducers/application'
import auth, { AuthState, initialAuthState } from 'embed/reducers/auth'
import config, { initialConfigState } from 'embed/reducers/config'
import filters, { FiltersState, initialFiltersState } from 'embed/reducers/filters'
import loading, { initialLoadingState, LoadingState } from 'embed/reducers/loading'
import params, { initialParamsState } from 'embed/reducers/params'
import parent, { initialParentState } from 'embed/reducers/parent'
import rates, { initialRatesState, RatesState } from 'embed/reducers/rates'
import experiments, { ExperimentsState, initialExperimentsState } from 'embed/experiments/reducers/experiments'
import { Config } from 'even-ts-static'
import { configStateSelector } from '../selectors/config'

export interface CommonState {
  application: ApplicationState
  auth: AuthState
  config: Config
  experiments: ExperimentsState
  filters: FiltersState
  loading: LoadingState
  params: ParamsState
  parent: object
  rates: RatesState
}

export interface MultiProductState extends CommonState {
  ui: ConfigProviderState
  waypoints: WaypointsState
}

export const initialCommonState: CommonState = {
  application: initialApplicationState,
  auth: initialAuthState,
  config: initialConfigState,
  experiments: initialExperimentsState,
  filters: initialFiltersState,
  loading: initialLoadingState,
  params: initialParamsState,
  parent: initialParentState,
  rates: initialRatesState,
}

export const initialMultiProductState: MultiProductState = {
  ...initialCommonState,
  ui: initialUiState,
  waypoints: initialWaypointsState,
}

const commonReducers = {
  application,
  auth,
  config,
  experiments,
  filters,
  loading,
  params,
  parent,
  rates,
}

const combineReducersWrapper = (globalState: MultiProductState, globalAction: AnyAction) => {
  // Provide the query params to reducers that need access to them.
  const reducers = {
    ...commonReducers,
    ui: (state: ConfigProviderState, action: ActionTypes) => ui(state, action, configStateSelector(globalState ?? {})),
    waypoints,
  }

  return combineReducers<MultiProductState>(reducers)(globalState, globalAction)
}

export default combineReducersWrapper
